var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"copy",on:{"click":function($event){$event.preventDefault();return _vm.copyToClipboard()}}},[_c('span',[_vm._v(_vm._s(_vm.$tc('ui.copy', Array.isArray(_vm.toCopy) ? _vm.toCopy.length : 1)))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.copied),expression:"copied"}],staticClass:"UI-icon UI-checked"})])
}
var staticRenderFns = []

export { render, staticRenderFns }